import React, { useState, useEffect } from "react";
import "../TotalCss.css";
import { api_url } from "../globalFunction/global_string";
import { Button } from "reactstrap";
import NYCUUserSet from "./NYCUUserSet";

const NYCUset = () => {


  return (
    <div>
      <div className="mt-5">
        <div className="header-with-button">
          <h1 id="tableLabel" className='mb-3'>NYCU登入使用者設定</h1>
        </div>
        <div id="site_manage" className="row col-12 mb-5">
        </div>
        <NYCUUserSet />
      </div>
    </div>
  );
}

export default NYCUset;
